import { createContext, useContext, useMemo, useState } from "react";
import { addMonths, getMonthRange, startOfMonth } from "./monthUtils";

export const GestockContext = createContext(null);
export const useGestock = () => useContext(GestockContext);

export function GestockProvider({ children }) {
  const [terminal, setTerminal] = useState("SEP");
  const [produit, setProduit] = useState("essence");

  // Restore last visited Gestock page from localStorage
  const savedPage = localStorage.getItem("gestockPage");
  const [activePage, setActivePage] = useState(savedPage || "dashboard");

  // Mois sélectionné — partagé par toutes les tables d'historique
  // (Commandes, Journal, Libre Pratique, Douane, Stations).
  const [selectedMonth, setSelectedMonth] = useState(() => startOfMonth(new Date()));

  const monthRange = useMemo(() => getMonthRange(selectedMonth), [selectedMonth]);
  const isCurrentMonth = selectedMonth.getTime() === startOfMonth(new Date()).getTime();

  const goToPrevMonth = () => setSelectedMonth((m) => addMonths(m, -1));
  const goToNextMonth = () =>
    setSelectedMonth((m) => {
      const now = startOfMonth(new Date());
      return m.getTime() >= now.getTime() ? m : addMonths(m, 1);
    });

  return (
    <GestockContext.Provider
      value={{
        terminal,
        setTerminal,
        produit,
        setProduit,
        activePage,
        setActivePage,
        selectedMonth,
        monthRange,
        isCurrentMonth,
        goToPrevMonth,
        goToNextMonth,
      }}
    >
      {children}
    </GestockContext.Provider>
  );
}
